import { useMutation, UseMutationResult } from 'react-query'

import api from 'api/index'
import { ApiError } from '../types/ApiError'

const deactivateDemo = (id: string): Promise<void> => api.post(`/demos/${id}/cancel`)

export const useDeactivateDemo = (): UseMutationResult<void, ApiError, string> => useMutation((id) => deactivateDemo(id))
